<template>
    <div id="distance-sidebar-menu" class="sidebar-menu-container">
        <div class="sidebar-main-label">Установите длину</div>
        <div class="sidebar-text-area">Теперь <span class="red-text bold-text">задайте расстояние</span>, соответствующее длине построенного отрезка
            <span class="red-text bold-text">на реальном участке</span>. Расстояние задаётся в поле ввода, расположенном на нижней панели.</div>
        <div class="sidebar-step-two-img-container">
            <img class="sidebar-step-two-img" :src="urlForStatic('/img/projectPreviewsDemo/perspective_tip_1.svg')"/>
        </div>
        <div class="sidebar-text-area">На этом шаге Вы также можете корректировать измерительную линию, перетаскиванием ее точек.</div>
    </div>
</template>

<script>
    import {urlForStaticVue} from "../../common";

    export default {
        name: "DistanceSidebarMenu",
        mixins: [urlForStaticVue]
    }
</script>

<style scoped>

</style>
